import type { ReactNode } from "react";

/**
 * The white paper panel every area screen sits in: the Blog's lists and settings and every Shop screen.
 * It scrolls on its own, so a SaveBar inside it sticks to the bottom of the panel.
 */
export function AreaPage({ area, children }: { area?: "blog" | "shop"; children: ReactNode }) {
  return <div className="bw-area-page" data-area={area}><div className="bw-area-inner">{children}</div></div>;
}
